import { BrowserRouter as Router } from "react-router-dom";
import GrandLayout from "components/layouts/GrandLayout";
import Routers from "Routers";
import { AuthProvider } from "context/AuthContext";

function App() {
  return (
    <div className="">
      <Router>
        <AuthProvider>
          <GrandLayout>
            <Routers />
          </GrandLayout>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;

// import { BrowserRouter as Router } from "react-router-dom";
// import GrandLayout from "components/layouts/GrandLayout";
// import Routers from "Routers";
// import { AuthProvider, useAuth } from "context/AuthContext";
// import PrivateRoute from "context/PrivateRoute";
// import PublicRoutes from "PublicRoutes";

// function App() {
//   // const { user } = useAuth();
//   const theStoredToken = localStorage.getItem("accessToken");

//   return (
//     <div className="">
//       <Router>
//         <AuthProvider>
//           {theStoredToken ? (
//             <PrivateRoute>
//               <GrandLayout>
//                 <Routers />
//               </GrandLayout>
//             </PrivateRoute>
//           ) : (
//             <GrandLayout>
//               <PublicRoutes />
//             </GrandLayout>
//           )}
//         </AuthProvider>
//       </Router>
//     </div>
//   );
// }

// export default App;
